webpackJsonp([40],{

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1385),
  /* template */
  __webpack_require__(1729),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _twitter = __webpack_require__(370);

var _twitter2 = _interopRequireDefault(_twitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'body-twitter',
  props: ['item'],
  mixins: [_twitter2.default],
  mounted: function mounted() {
    var _this = this;

    this.$watch('$refs.lazy.state.loaded', function () {
      if ((0, _get2.default)(_this, '$refs.lazy.state.loaded')) {
        _this.loadTwitterScript();
      }
    });
  }
};

/***/ }),

/***/ 1729:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lazy-component', {
    ref: "lazy",
    staticClass: "twitter-lazy-wrapper",
    attrs: {
      "tag": "div"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.html)
    }
  })])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 40.0e36596d00819388728c.js